import React, { FC } from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import classnames from "classnames";
import { PartialPost } from "../../types/types";
import styles from "./Cards.module.scss";
import StarIcon from "../../assets/heroicons/star.svg";
import { Button } from "../Button/Button";
import PlayIcon from "../../assets/heroicons/play.svg";

export interface PostCardProps {
	content: PartialPost;
	/** Add a 'featured' flag to the top left of the image */
	isFeatured?: boolean;
	/** This will determine the 'featured' text e.g. "featured article" */
	type?: string;
	/** Text for the cta at the bottom of the card */
	cta?: string;
}

export const PostCard: FC<PostCardProps> = ({
	content: {
		uid,
		first_publication_date,
		first_publication_date_formatted,
		data: { title, image, summary, is_featured },
	},
}) => (
	<article className={styles.card}>
		<div className={styles.imageContainer}>
			<GatsbyImage
				className={styles.image}
				image={image.fluid}
				alt={image.alt || title}
			/>
			{is_featured && (
				<span className={classnames([styles.featuredFlag, styles.article])}>
					<StarIcon
						focusable="false"
						aria-hidden="true"
						className={styles.icon}
					/>
					Featured
				</span>
			)}
		</div>
		<div className={styles.text}>
			<h2 className={styles.heading}>
				<Link to={`/resource-centre/${uid}`} className={styles.link}>
					{title}
				</Link>
			</h2>
			{/* <p className={styles.author}>By {author.document.data.name}</p> */}

			<time className={styles.date} dateTime={first_publication_date}>
				{first_publication_date_formatted}
			</time>
			<p className={styles.summary}>{summary}</p>
			<div className={styles.buttons}>
				<Button
					to={`/resource-centre/${uid}`}
					target="_blank"
					className={styles.fullWidthButton}
				>
					<PlayIcon
						focusable="false"
						aria-hidden="true"
						className={styles.icon}
					/>
					Read article
				</Button>
			</div>
			{/* <p>
				<Link to={`/resource-centre/${uid}`} tabIndex={-1}>
					Read article
					<span className="visuallyHidden">: {title}</span>
				</Link>
			</p> */}
		</div>
	</article>
);
